// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__UJ5Fn","page":"layout_page__fsaUw"};